<template>
	<div class="applyform">
		<ul>
			<li>
				<p class="name">姓名</p>
				<input type="text" v-model="form.customerName" name="customerName" placeholder="请输入姓名">
			</li>
			<li>
				<p class="email">邮箱</p>
				<input type="text" v-model="form.mailbox" name="mailbox" placeholder="请输入邮箱">
			</li>
			<li>
				<p class="phone">电话</p>
				<input type="text" v-model="form.phone" name="phone" placeholder="请输入电话" maxlength="11">
			</li>
		</ul>
		<a href="javascript:;" class="get" @click="addCustomer">申请获取</a>
		<Confirm ref="confirm" :text="msg"></Confirm>
	</div>
</template>
<script>
	import axios from 'axios'
	import { stringify } from 'qs'
	import Confirm from './Confirm'
	export default {
		name: 'GetForm',
		components: {
			Confirm
		},
		data () {
			return {
				form: {
					customerName: '',
					mailbox: '',
					phone: '',
					type: this.$route.name,
					source: 1
				},
				msg: ''
			}
		},
		methods: {
			addCustomer: function() {
				let _this = this
				let params = {
					customerName: this.form.customerName,
					mailbox: this.form.mailbox,
					phone: this.form.phone,
					type: this.$route.name,
					source: 1
				}
				let phone = this.form.phone
				let email = this.form.mailbox
				var reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/

					if(!reg.test(email)) {
						_this.msg = '请正确填写邮箱'
						_this.$refs.confirm.show()
					}
					else if (!(/^1[34578]\d{9}$/.test(phone))) {
						  _this.msg = '请输入正确的手机号'
						  _this.$refs.confirm.show()
					 } else if (phone == '' || !phone) {
						 _this.msg = '请输入手机号'
						 _this.$refs.confirm.show()
				         
				      } else {
						axios.post('/api/customer/add',stringify(params))
						.then(function (response) {
							_this.msg = '申请获取成功'
							_this.$refs.confirm.show()
						})
						.catch(function (error) {
							console.log(error);
						})
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import '../../base/scss/mixin';
	.applyform {
		width: 435px - 88px - 88px;
		height: 390px - 42px;
		margin: 0 auto;
		padding: 42px 88px 0;
		border-radius: 8px;
		background: #f2f2f4;
		box-shadow: 0 4px 4px rgba(0,0,0,.15);
		ul {
			margin-bottom: 30px;
		}
		li {
			margin-bottom: 18px;
		}
		input {
			width: 260px - 2px - 27px;
			height: 35px - 2px;
			padding-left: 27px;
			border: 1px solid #ededed;
			border-radius: 4px;
			background: #fff;
			box-shadow: 0 0 4px #ededed;
			font-family: "黑体","SimHei";
			font-size: 14px;
		}
		input::-webkit-input-placeholder {
			color: #bfbfbf;
		}
		input::-ms-input-placeholder {
			color: #bfbfbf;
		}
		input::-moz-input-placeholder {
			color: #bfbfbf;
		}
		p {
			margin-bottom: 10px;
			padding-left: 30px;
			line-height: 20px;
			font-size: 14px;
		}
		.name {
			background: url(../../assets/base/name.png) left center no-repeat;
		}
		.email {
			background: url(../../assets/base/email.png) left center no-repeat;
		}
		.phone {
			background: url(../../assets/base/dianhua.png) left center no-repeat;
		}
	}
	.get {
		display: block;
		margin: 0 auto;
		width: 260px;
		@include lh(38px)
		background: #1a58a2;
		border-radius: 4px;
		font-size: 18px;
		color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/ApplyForm.vue